<div id="siteCard" [attr.data-qaa]="siteCardSpec.registration_id">
    <dsy-card height="auto" round-border="true" no-padding="true" (click)="siteCardSpec.onClickAction()">
        <div class="d-flex siteCard" [ngClass]="{'siteCard-selected':siteCardSpec.isChecked }">
            <div class="col-2 py-5 d-flex justify-content-center align-items-center" style="padding-left:16px;padding-right:16px">
                <input class="form-check-input radio-sidebar" type="radio"
                    name="flexRadioDefault{{siteCardSpec.event_node_index}}{{siteCardSpec.index}}"
                    id={{siteCardSpec.siteName}}{{siteCardSpec.event_node_index}}{{siteCardSpec.index}}
                    [checked]="siteCardSpec.isChecked">
            </div>
            <div class="col-10 py-3 px-2 site-content" [attr.data-qaa]="siteCardSpec.registration_id + '-details'">
                <span class="text-titleList d-flex pt-2" data-qaa="site-name">{{siteCardSpec.siteName}}</span>
                <div class="content-wrap" *ngIf="siteCardSpec.enableSiteDetails && siteCardSpec.registration">
                    <span> {{ 'DISPATCH_LIST.SITE_CARD.SITE_DETAILS' | translate }} </span>
                    <span class="text-subtitleList" data-qaa="registration-name">
                        {{siteCardSpec.registration.display_label}}</span>
                </div>
                <div>
                    <span> {{ 'DISPATCH_LIST.SITE_CARD.PERFORMANCE' | translate }} </span>
                    <span class="text-subtitleList" [ngClass]="siteCardSpec.performanceLabel" data-qaa="performance">
                        {{siteCardSpec.performance !== null ? (siteCardSpec.performance | percent) : '--'}}</span>
                </div>
                <div>
                    <span> {{ 'DISPATCH_LIST.SITE_CARD.REDUCTION' | translate }} </span>
                    <span class="text-subtitleList" data-qaa="reduction"> {{siteCardSpec.reduction}}</span>
                </div>
            </div>
        </div>
    </dsy-card>
</div>